import { Button } from "@chakra-ui/button";
import {
  Box,
  Flex,
  Grid,
  HStack,
  Stack,
  StackDivider,
  Text,
} from "@chakra-ui/layout";
import { Radio, RadioGroup } from "@chakra-ui/radio";
import { faCheck, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import programs from "../lib/programs.json";

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SubscribeToProgram = () => {
  let query = useQuery();
  const history = useHistory();
  const [program, setProgram] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState("");

  useEffect(() => {
    //   get the programId from the param
    let programId = query.get("programId");

    let activeProgram = programs.find((program) => program._id === programId);
    setProgram(activeProgram);
    setLoading(false);
  }, [query]);

  return (
    <>
      <Grid
        sx={{
          gridTemplateAreas: "'top' 'bottom'",
          height: "100%",
          gridTemplateRows: "auto 1fr",
        }}
      >
        <Box sx={{ gridArea: "top" }}>
          <Box sx={{ px: "8", py: "6" }}>
            <HStack
              gap="4"
              alignItems="center"
              onClick={() => history.push("/dashboard/knowledge-bank/")}
              color="#00A2E7"
              sx={{
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
              <Text>Knowledge Bank</Text>
            </HStack>

            <Text sx={{ fontSize: "22px", fontWeight: "bold", mt: 4 }}>
              Subscribe
            </Text>
          </Box>

          <Box
            sx={{
              hr: {
                bg: "#adb5bd",
              },
            }}
          >
            <hr />
          </Box>
        </Box>
        <Grid sx={{ gridArea: "bottom" }} templateColumns="1fr auto 3fr">
          <Box>
            {!loading && (
              <Stack
                divider={<StackDivider borderColor="gray.200" />}
                gap={4}
                mb={3}
                lines={3}
              >
                <Flex mx="8" my="3" justify="space-between" align="center">
                  <Text>{program.title}</Text>
                  <Text color="#00A2E7" fontSize="18px" fontWeight="bold">
                    {program.duration[0].price}
                  </Text>
                </Flex>

                <Box mx="8" my="3">
                  {program.summary}
                </Box>
              </Stack>
            )}
          </Box>

          <Box sx={{ width: "1.5px", height: "100%", bg: "#adb5bd" }}></Box>

          <Box>
            {/* base */}
            <Box mx="6rem" my="3rem">
              {!loading && (
                <>
                  <Stack mb="6">
                    {program.features.map((feature) => (
                      <HStack>
                        <FontAwesomeIcon icon={faCheck} />
                        <Text>{feature.summary}</Text>
                      </HStack>
                    ))}
                  </Stack>
                  <RadioGroup
                    onChange={setSelectedPlan}
                    value={selectedPlan}
                    sx={{ position: "relative" }}
                  >
                    <Stack
                      divider={<StackDivider borderColor="gray.200" />}
                      direction="column"
                    >
                      {program.duration.map((duration) => (
                        <Radio value={duration._id}>
                          <Flex
                            ml="4"
                            py={3}
                            sx={{
                              width: "100%",
                            }}
                            justify="space-between"
                            align="center"
                          >
                            <Text>{duration.price}</Text>
                            <Text>{duration.timeLength}</Text>
                          </Flex>
                        </Radio>
                      ))}
                    </Stack>
                  </RadioGroup>

                  <Button
                    isFullWidth
                    backgroundColor="#00A2E7"
                    color="#fff"
                    mt="5"
                  >
                    Pay now and save
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default SubscribeToProgram;
